import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
// import { Navigate, Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'react-redux';
import { userSelector } from '../features/user/userSlice';

import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
// import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

// import PeopleIcon from '@mui/icons-material/People';
// import LockIcon from '@mui/icons-material/Lock';

function Home() {
  const { t } = useTranslation(['common', 'maintenance']);

  const { user } = useSelector(userSelector);

  // if (!user) {
  //   return <Navigate to="/login" />;
  // }

  return (
    <Container maxWidth="false" sx={{ mt: 2, mb: 3 }}>
      {/* <Typography variant="h4" component="div" gutterBottom>
        {t('home')}
      </Typography> */}
      {user?.username &&
      user?.username !== 'reader' &&
      user?.roles.some((role) => role === 'admin' || role === 'production') ? (
        <Container maxWidth="md" sx={{ p: 2 }}>
          <Paper sx={{ p: 2 }} variant="outlined">
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-evenly',
                gap: '1em',
              }}
            >
              {user?.roles.some(
                (role) => role === 'admin' || role === 'production'
              ) ? (
                <Box sx={{ display: 'flex', flex: '1 1 100%' }}>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{ px: 4, py: 3, textAlign: 'center' }}
                    component={RouterLink}
                    to="/create-maintenance-task"
                  >
                    {t('maintenance:create_maintenance_task')}
                  </Button>
                </Box>
              ) : null}
            </Box>
          </Paper>
        </Container>
      ) : null}
      <Container maxWidth="md" sx={{ p: 2 }}>
        <Paper sx={{ p: 2 }} variant="outlined">
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-evenly',
              gap: '1em',
            }}
          >
            <Box sx={{ display: 'flex', flex: '1 1 100%' }}>
              <Button
                variant="contained"
                fullWidth
                sx={{ px: 4, py: 3, textAlign: 'center' }}
                component={RouterLink}
                to="/maintenance-task-list"
              >
                {t('maintenance:maintenance_tasks')}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
      <Container maxWidth="md" sx={{ p: 2 }}>
        <Paper sx={{ p: 2 }} variant="outlined">
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-evenly',
              gap: '1em',
            }}
          >
            <Box sx={{ display: 'flex', flex: '1 1 100%' }}>
              <Button
                variant="contained"
                fullWidth
                sx={{ px: 4, py: 3, textAlign: 'center' }}
                component={RouterLink}
                to="/report-maintenance-tasks"
              >
                {t('maintenance:report_maintenance_tasks')}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
      {user?.roles.some((role) => role === 'admin') && (
        <Container maxWidth="md" sx={{ p: 2 }}>
          <Paper sx={{ p: 2 }} variant="outlined">
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-evenly',
                gap: '1em',
              }}
            >
              <Box sx={{ display: 'flex', flex: '1 1 100%' }}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{ px: 4, py: 3, textAlign: 'center' }}
                  component={RouterLink}
                  to="/manage-layout"
                >
                  {t('maintenance:manage_layout')}
                </Button>
              </Box>
            </Box>
          </Paper>
        </Container>
      )}
      {/* {user?.roles.some((role) => role === 'admin' || role === 'products') && (
        <Container maxWidth="md" sx={{ p: 2 }}>
          <Paper sx={{ p: 2 }} variant="outlined">
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-evenly',
                gap: '1em',
              }}
            >
              {user?.roles.some(
                (role) => role === 'admin' || role === 'products'
              ) && (
                <>
                  <Box sx={{ display: 'flex', flex: '1 1 100%' }}>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{ px: 4, py: 3, textAlign: 'center' }}
                      component={RouterLink}
                      to="/products"
                    >
                      {t('product:products')}
                    </Button>
                  </Box>
                  <Box sx={{ display: 'flex', flex: '1 1 100%' }}>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{ px: 4, py: 3, textAlign: 'center' }}
                      component={RouterLink}
                      to="/manageworkflows"
                    >
                      {t('workflow:manage_workflows')}
                    </Button>
                  </Box>
                </>
              )}
              {user?.roles.some((role) => role === 'admin') && (
                <Box sx={{ display: 'flex', flex: '1 1 100%' }}>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{ px: 4, py: 3, textAlign: 'center' }}
                    component={RouterLink}
                    to="/users"
                    startIcon={<PeopleIcon />}
                  >
                    {t('user:users')}
                  </Button>
                </Box>
              )}
            </Box>
          </Paper>
        </Container>
      )}
      {user?.roles.some((role) => role === 'admin' || role === 'quality') && (
        <Container maxWidth="md" sx={{ p: 2 }}>
          <Paper sx={{ p: 2 }} variant="outlined">
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-evenly',
                gap: '1em',
              }}
            >
              {user?.roles.some(
                (role) => role === 'admin' || role === 'quality'
              ) && (
                <>
                  <Box sx={{ display: 'flex', flex: '1 1 100%' }}>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{ px: 4, py: 3, textAlign: 'center' }}
                      component={RouterLink}
                      to="/blocking"
                      startIcon={<LockIcon />}
                    >
                      {t('blocking:blocking_and_release')}
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Paper>
        </Container>
      )}
      {user?.roles.some((role) => role === 'admin' || role === 'defaults') && (
        <Container maxWidth="md" sx={{ p: 2 }}>
          <Paper sx={{ p: 2 }} variant="outlined">
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-evenly',
                gap: '1em',
              }}
            >
              {user?.roles.some(
                (role) => role === 'admin' || role === 'defaults'
              ) && (
                <>
                  <Box sx={{ display: 'flex', flex: '1 1 100%' }}>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{ px: 4, py: 3, textAlign: 'center' }}
                      component={RouterLink}
                      to="/managedefaultareas"
                    >
                      {t('product:manage_default_areas')}
                    </Button>
                  </Box>
                  <Box sx={{ display: 'flex', flex: '1 1 100%' }}>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{ px: 4, py: 3, textAlign: 'center' }}
                      component={RouterLink}
                      to="/managedefaultcauses"
                    >
                      {t('product:manage_default_causes')}
                    </Button>
                  </Box>
                  <Box sx={{ display: 'flex', flex: '1 1 100%' }}>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{ px: 4, py: 3, textAlign: 'center' }}
                      component={RouterLink}
                      to="/managewfdcauses"
                    >
                      {t('product:manage_wfd_causes')}
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Paper>
        </Container>
      )} */}
    </Container>
  );
}

export default Home;
